// src/components/Header.js

import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './Header.css';

import logoImage from '../assets/logo_golden.png';

const Header = () => {
  // Mobile menu state
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Current route location
  const location = useLocation();

  // Close menu on route change (important for mobile)
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className="app-header">
      {/* Logo */}
      <NavLink to="/" className="logo-link" onClick={closeMenu}>
        <img src={logoImage} alt="Govindam Logo" className="logo-image" />
      </NavLink>

      {/* Navigation */}
      <nav className={isMenuOpen ? "main-nav active" : "main-nav"}>
        <NavLink to="/" onClick={closeMenu}>Home</NavLink>
        <NavLink to="/about" onClick={closeMenu}>About</NavLink>
        <NavLink to="/contact" onClick={closeMenu}>Contact</NavLink>
        <NavLink to="/buyer" onClick={closeMenu}>Buyer Login</NavLink>
        <NavLink to="/mediator" onClick={closeMenu}>Mediator Login</NavLink>
        <NavLink to="/apps" onClick={closeMenu}>Apps & Extensions</NavLink>
      </nav>

      {/* Hamburger */}
      <div
        className={isMenuOpen ? "hamburger-menu active" : "hamburger-menu"}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>
    </header>
  );
};

export default Header;
